<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col
        :span="4"
        class="cs-main-left-container"
      >
        <navigator></navigator>
      </el-col>
      <el-col
        :span="20"
        class="backgroud-gray cs-fullHeight cs-main-right-container"
      >
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">积分兑换物品管理</span>
                <el-row class="grid-content">
                  <el-col>
                    <pagination
                      v-loading="loading"
                      :option="optionsForComponents.pagination"
                      :data="dataForComponents.pagination"
                      @search="search"
                      @add="add"
                      @edit="edit"
                    ></pagination>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :center="true"
      :close-on-click-modal="false"
      width="600px"
      :visible.sync="bpeItemEditVisible"
      top="3vh"
    >
      <bpe-item-edit
        :options="optionsForComponents.bpeItemEdit"
        :data="dataForComponents.bpeItemEdit"
        @closeDialog="onBPEItemEditClose"
        @saveSuccess="onBPEItemEditSaveSuccess"
      ></bpe-item-edit>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import navigator from "../../components/navigator";
import pagination from "../../components/common/pagination";
import bpeItemEdit from "../../components/bpeItemManagement/bpeItemEdit";

import { getBonusPointExchangeItemsPageData } from "../../service/bonusPoint.service";

export default {
  data() {
    return {
      loading: false,
      bpeItemEditVisible: false,
      pageCondition: {
        keyWord: null
      },
      optionsForComponents: {
        pagination: {
          displayPagination: false,
          hasEditButton: true,
          editButtonText: "编辑",
          hasAddButton: true,
          addButtonText: "添加",
          hasSearch: true
        },
        bpeItemEdit: {
          showTitle: true
        }
      },
      dataForComponents: {
        pagination: [],
        bpeItemEdit: {
          index: -1,
          item: null
        }
      }
    };
  },
  components: {
    navigator,
    pagination,
    bpeItemEdit
  },
  mounted() {
    this.reloadOptionsForPagination();
    this.loadBonusPointExchangeItemListDataFromServer();
  },
  methods: {
    async loadBonusPointExchangeItemListDataFromServer(
      pageCondition = this.pageCondition
    ) {
      this.loading = true;

      let result = await getBonusPointExchangeItemsPageData(pageCondition);
      if (!!result && result.success) {
        this.dataForComponents.pagination = result.data;
      } else {
        this.dataForComponents.pagination = [];
      }

      this.loading = false;
    },
    reloadOptionsForPagination() {
      let newOptions = {
        displayPagination: false,
        hasEditButton: true,
        editButtonText: "编辑",
        hasAddButton: true,
        addButtonText: "添加",
        hasSearch: true
      };

      newOptions.hasEditButton = this.USERMANAGER.isAdmin;
      newOptions.hasAddButton = this.USERMANAGER.isAdmin;

      this.optionsForComponents.pagination = newOptions;
    },
    search: function(keyword) {
      this.pageCondition.keyWord = keyword;
      this.loadBonusPointExchangeItemListDataFromServer();
    },
    add: function() {
      let newData = {
        index: -1,
        item: null
      };

      this.dataForComponents.bpeItemEdit = newData;
      this.bpeItemEditVisible = true;
    },
    edit: function(index, row) {
      let newData = {
        index: -1,
        item: null
      };

      newData.index = index;
      newData.item = row;

      this.dataForComponents.bpeItemEdit = newData;
      this.bpeItemEditVisible = true;
    },
    onBPEItemEditClose() {
      this.bpeItemEditVisible = false;
    },
    onBPEItemEditSaveSuccess(dataOut) {
      if (dataOut.index < 0) {
        this.dataForComponents.pagination.Results.push(dataOut.item);
        return;
      }

      let row = this.dataForComponents.pagination.Results[dataOut.index];
      if (!row) return;

      $.extend(true, row, dataOut.item);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/admin/bpeItemManagement.vue